// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2lcq8","signatureButtonsRight":"ModalSign_signatureButtonsRight__1ZVhq"};